module.exports = __webpack_public_path__ + "img/9.2b401606.png";